import { useState, useContext } from 'react';

import { observer } from 'mobx-react-lite';

import SideBar from 'components/common/SideBar/SideBar';
import Button from 'components/common/Button/Button';
import { RootStoreContext } from 'index';
import { ToastMessage } from 'components/common/Toast/toast.enums';
import { notify } from 'components/common/Toast/toast.helpers';

import { RoleDto } from '../../roles.dto';
import styles from './DeleteRoleDialog.module.scss';

interface DeleteRoleDialogProps {
  isOpen: boolean;
  currentRole?: RoleDto;
  onClose: () => void;
}

const DeleteRoleDialog = observer(({ isOpen, currentRole, onClose }: DeleteRoleDialogProps) => {
  const { rolesStore } = useContext(RootStoreContext);
  const [isDeleting, setIsDeleting] = useState(false);

  const handleDelete = async () => {
    if (!currentRole) {
      return;
    }

    setIsDeleting(true);

    try {
      await rolesStore.deleteRole(currentRole.id);
      notify(ToastMessage.RoleDeleted, 'success');
    } catch (err: any) {
      notify(err.message, 'error');
    } finally {
      setIsDeleting(false);
      onClose();
    }
  };

  return (
    <SideBar title={`Delete ${currentRole?.name ?? 'Role'}`} isOpen={isOpen} onClose={onClose}>
      <p className={styles.title}>
        Are you sure you want to delete this role – <strong>{currentRole?.name}</strong>?
      </p>
      <div className={styles.wrapButton}>
        <Button onClick={handleDelete} isLoading={isDeleting}>
          Yes, Delete {currentRole?.name}
        </Button>
        <Button variant="white" onClick={onClose} isLoading={isDeleting}>
          No, Go Back
        </Button>
      </div>
    </SideBar>
  );
});

export default DeleteRoleDialog;
